import { useEffect, useState } from 'react';
import { getContacts } from './api';
import SectionHeader from './SectionHeader';

export default function ContactsBlock({ petId, docs, onDocsClick }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getContacts(petId)
      .then(setContacts)
      .catch(() => setContacts([]))
      .finally(() => setLoading(false));
  }, [petId]);

  if (loading) return null;

  return (
    <section className="card-section" id="section-contacts">
      <SectionHeader
        title="Контакты"
        sectionKey="contacts"
        docs={docs}
        onDocsClick={onDocsClick}
      />
      {contacts.length === 0 ? (
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Нет контактов</p>
      ) : (
        contacts.map((c) => (
          <div key={c.id} className="contact-card">
            <div className="contact-spec">🏥 {c.specialization}</div>
            {c.clinic_name && <div className="contact-detail">🏢 {c.clinic_name}</div>}
            {c.doctor_name && <div className="contact-detail">👤 {c.doctor_name}</div>}
            {(c.phone_country_code || c.phone_number) && (
              <div className="contact-detail">
                📞 <span className="contact-copyable" onClick={() => navigator.clipboard?.writeText(`${c.phone_country_code || ''}${c.phone_number}`)}>
                  {c.phone_country_code ? `${c.phone_country_code} ` : ''}{c.phone_number}
                </span>
              </div>
            )}
            {c.email && (
              <div className="contact-detail">
                ✉️ <span className="contact-copyable" onClick={() => navigator.clipboard?.writeText(c.email)}>{c.email}</span>
              </div>
            )}
          </div>
        ))
      )}
    </section>
  );
}
